import { GuidanceSettingProps } from './index';

export interface IRoomsDataStorage {
  [key: string]: boolean | string;
}

// export interface ISetStorageData {
//   hidden: boolean; // if false - then item hidden from menu. // Need to be changed. active: boolean.
// }

export const setSettingsItemInStorage = (data: boolean, itemPath: string) => {
  const prevData: IRoomsDataStorage = JSON.parse(localStorage.getItem('settings_menu') || '{}');

  localStorage.setItem(
    'settings_menu',
    JSON.stringify({
      ...prevData,
      [itemPath]: data,
    }),
  );
};

export const setInfoTracSettingsInStorage = (data: IRoomsDataStorage) => {
  localStorage.setItem('settings_menu', JSON.stringify(data));
};

export const getSettingItemFromStorage = (itemPath: string) => {
  const item = localStorage.getItem('settings_menu');

  const routeData: boolean | undefined = JSON.parse(item || '{}')?.[itemPath];

  return routeData;
};

export const getAllSettingsFromStorage = (): IRoomsDataStorage =>
  JSON.parse(localStorage.getItem('settings_menu') || '{}');

/** Guidance */
export const getGuidanceSettingsFromStorage = (): GuidanceSettingProps =>
  JSON.parse(localStorage.getItem('settings_guidance') || '{}');

export const setGuidanceSettingsInStorage = (data: GuidanceSettingProps) => {
  localStorage.setItem('settings_guidance', JSON.stringify(data));
};
